import api from "utils/api";
import { appApiEndpoint } from "environment";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const createShortApplication = createAsyncThunk(
  "candidates/createShortApplication",
  async (arg, thunkAPI) => {
    const jobBoardPermalink = arg.jobBoardPermalink;
    const payload = arg.payload;

    const withCredentials = false;
    try {
      const response = await api.post(
        withCredentials,
        `${appApiEndpoint}/v1/public/job-boards/${jobBoardPermalink}/short-applications`,
        {},
        payload
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const createApplication = createAsyncThunk(
  "candidates/createApplication",
  async (arg, thunkAPI) => {
    const jobBoardPermalink = arg.jobBoardPermalink;
    const payload = arg.payload;

    const withCredentials = false;
    try {
      const response = await api.post(
        withCredentials,
        `${appApiEndpoint}/v1/public/job-boards/${jobBoardPermalink}/applications`,
        {},
        payload
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const optOutAppReminders = createAsyncThunk(
  "candidates/optOutAppReminders",
  async (arg, thunkAPI) => {
    const sequenceTargetPermalink = arg.sequenceTargetPermalink;
    const payload = arg.payload;

    const withCredentials = false;
    try {
      const response = await api.post(
        withCredentials,
        `${appApiEndpoint}/v1/public/sequences/${sequenceTargetPermalink}/opt-out`,
        {},
        payload
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
